export default "__VITE_ASSET__CTzF0oPB__"